'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeTotals = exports.getAmountByCurrency = exports.getMonetaryValue = exports.fetchTotals = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _client = require('../client');

var _params = require('../params');

var _tags = require('../tags');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var fetchTotals = exports.fetchTotals = function fetchTotals(_ref) {
  var _ref$segment = _ref.segment,
      segment = _ref$segment === undefined ? (0, _params.required)() : _ref$segment,
      _ref$tagId = _ref.tagId,
      tagId = _ref$tagId === undefined ? (0, _params.required)() : _ref$tagId,
      _ref$tagValue = _ref.tagValue,
      tagValue = _ref$tagValue === undefined ? (0, _params.required)() : _ref$tagValue;

  var query = '\n    {\n      totals(\n        segment: "' + segment + '",\n        tagDefinitionId: "' + tagId + '",\n        tagValue: "' + tagValue + '"\n      ) {\n        measurementDomain\n        amounts {\n          value\n          unit\n        }\n      }\n    }\n  ';

  return _client.servicesAPI.post('/v1/justgiving/graphql', { query: query }).then(function (response) {
    return response.data;
  }).then(function (result) {
    return (0, _get2.default)(result, 'data.totals', []);
  });
};

var getMonetaryValue = exports.getMonetaryValue = function getMonetaryValue(val) {
  return (0, _get2.default)(val, 'value', 0) / 100;
};

var getAmountByCurrency = exports.getAmountByCurrency = function getAmountByCurrency() {
  var amounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GBP';
  return (0, _get2.default)((0, _find2.default)(amounts, { unit: currency.toLowerCase() }), 'value', 0);
};

var deserializeTotals = exports.deserializeTotals = function deserializeTotals(totals) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GBP';
  return _tags.measurementDomains.map(function (measurementDomain) {
    return (0, _find2.default)(totals, { measurementDomain: measurementDomain }) || { measurementDomain: measurementDomain };
  }).reduce(function (acc, _ref2) {
    var measurementDomain = _ref2.measurementDomain,
        _ref2$amounts = _ref2.amounts,
        amounts = _ref2$amounts === undefined ? [] : _ref2$amounts;

    var label = measurementDomain.split(':')[0];
    var unit = (0, _tags.getPrimaryUnit)(measurementDomain);
    var value = (0, _get2.default)((0, _find2.default)(amounts, { unit: unit }), 'value', 0);

    switch (measurementDomain) {
      case 'fundraising:donations_received':
        return _extends({}, acc, {
          raised: getAmountByCurrency(amounts, currency)
        });

      case 'fundraising:donations_made':
        return _extends({}, acc, {
          donations: value
        });

      case 'any:activities':
        return _extends({}, acc, {
          fitnessCount: value
        });

      case 'walk:activities':
      case 'ride:activities':
      case 'swim:activities':
      case 'hike:activities':
        return _extends({}, acc, _defineProperty({}, label + 'Count', value));

      case 'any:distance':
        return _extends({}, acc, {
          fitnessDistanceTotal: value
        });

      case 'walk:distance':
      case 'ride:distance':
      case 'swim:distance':
      case 'hike:distance':
        return _extends({}, acc, _defineProperty({}, label + 'DistanceTotal', value));

      case 'any:elapsed_time':
        return _extends({}, acc, {
          fitnessDurationTotal: value
        });

      case 'walk:elapsed_time':
      case 'ride:elapsed_time':
      case 'swim:elapsed_time':
      case 'hike:elapsed_time':
        return _extends({}, acc, _defineProperty({}, label + 'DurationTotal', value));

      case 'any:elevation_gain':
        return _extends({}, acc, {
          fitnessElevationTotal: value
        });

      case 'walk:elevation_gain':
      case 'ride:elevation_gain':
      case 'swim:elevation_gain':
      case 'hike:elevation_gain':
        return _extends({}, acc, _defineProperty({}, label + 'ElevationTotal', value));

      default:
        return acc;
    }
  }, {});
};